import { observable, reaction, action } from 'mobx'
import GlobalControlStore from './GlobalControlStore'
import RegionalDivisionStore from './RegionalDivisionStore'
import { getGroupFetchHandler, updateGroupFetchHandler } from '../utils/fetchData'

/*

*/

class GroupInfoStore {
  @observable ownerInfo = null
  @observable groupName = null
  @observable groupId = null
  @observable groupPhone = null
  @observable groupEmail = null
  @observable groupLocation = null
  @observable cleanerInfoMap = new Map()
  @observable adminInfoMap = new Map()
  @observable needUpdate = false
  @observable ownerName = ''
  @observable adminArr = []
  @observable cleanerNum = 0
  @observable cleanCarNum = 0

  addUserToMaps(userList) {
    userList.forEach((user) => {
      switch (user.role) {
        case 'ADMIN': {
          this.adminInfoMap.set(user.id, user)
          break
        }
        case 'CLEANER': {
          this.cleanerInfoMap.set(user.id, user)
          break
        }
        default: {
          break
        }
      }
    })
  }
  @action.bound
  updateGroup = async (body) => {
    await Promise.all([updateGroupFetchHandler(
      body,
      () => {
        this.needUpdate = true
      },
      (data) => {
        console.log(data)
      }
    )])
  }
}
const store = new GroupInfoStore()

const forceUpdateReaction = reaction(
  () => store.needUpdate,
  (needUpdate, reaction) => {
    if (needUpdate) {
      getGroupFetchHandler(
        (data) => {
          store.cleanerInfoMap.clear()
          store.adminInfoMap.clear()
          store.ownerInfo = data.owner
          store.addUserToMaps(data.cleaners)
          store.addUserToMaps(data.admins)
          store.addUserToMaps(data.newComers)
          store.ownerName = data.owner.name || data.owner.username
          store.groupPhone = data.owner.phone || null
          store.groupName = data.name || null
          store.groupId = data.owner.groupId
          store.groupEmail = data.email || null
          store.groupLocation = data.location || null
          store.adminArr.clear()
          store.adminArr = data.admins
          store.needUpdate = false
          store.cleanerNum = data.cleaners_number || 0
          store.cleanCarNum = data.cars_number || 0
        },
        (err) => {},
        () => {
          GlobalControlStore.showLoading = false
        }
      )
    }
  }
)
export default store



// WEBPACK FOOTER //
// ./src/store/GroupInfoStore.js